import DatePicker from "../DatePicker/DatePicker";
import {getSpamUserDetails } from "../../services/merpservices";

const SpamCallReport = ({
  empid,
  ak,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  onSubmit,
  spamCallData,
  setSpamCallData,
  reportType,
  setReportType,
  setMessage
}) => {
  const handleCheckboxChange = (value) => {
    // if same value clicked → uncheck it, else set new one
    if (reportType === value) {
      setReportType(""); // uncheck
    } else {
      setReportType(value);
    }
    setSpamCallData([])
    setMessage("")
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!reportType) return alert("Please select a report type.");
    if (!startDate || !endDate) return alert("Please select both start and end dates.");
    if (startDate > endDate) return alert("Start date cannot be after end date.");

    try {
      const typeFlag = reportType === "spam" ? "block" : "unblock";
      const response = await getSpamUserDetails(empid, ak, typeFlag, startDate, endDate);

      if (response?.data?.status === 200) {
        const records = response?.data?.data || [];
        if (records.length === 0) {
          setMessage(<p style={{ color: "red" }}>No records found !!!</p>);
          setSpamCallData([]);
        } else {
          setMessage("");
          setSpamCallData(records);
        }
      } else {
        setMessage(<p style={{ color: "red" }}>Unexpected response. Please try again.</p>);
        setSpamCallData([]);
      }

      onSubmit?.({ reportType, startDate, endDate });
    } catch (error) {
      console.error("Error fetching spam call data:", error);
      setMessage(<p style={{ color: "red" }}>Error fetching data. Please try again later.</p>);
      setSpamCallData([]);
    }
  };


  return (
    <form>
      <div className="calldump-form-group">
        <label>Start Date:</label>
        <DatePicker value={startDate} onChange={setStartDate} />
      </div>
      <div className="calldump-form-group">
        <label>End Date:</label>
        <DatePicker value={endDate} onChange={setEndDate} />
      </div>

      <div className="calldump-checkbox-group">
        <div>
          <label htmlFor="spam" style={{ marginRight: "10px" }}>
            Spam Call Report
          </label>
          <input
            type="checkbox"
            id="spam"
            name="reportType"
            value="spam"
            checked={reportType === "spam"}
            onChange={() => handleCheckboxChange("spam")}
          />
        </div>
        <div>
          <label htmlFor="unblock" style={{ marginRight: "10px" }}>
            Unblock Spam
          </label>
          <input
            type="checkbox"
            id="unblock"
            name="reportType"
            value="unblock"
            checked={reportType === "unblock"}
            onChange={() => handleCheckboxChange("unblock")}
          />
        </div>
      </div>

      <div className="calldump-buttons">
        <button type="submit" onClick={handleSubmit}>
          Submit
        </button>
      </div>
    </form>
  );
};

export default SpamCallReport;